module.exports = __webpack_public_path__ + "img/logo-white.81c8d3e9.png";